import { Typography } from "@kyan/ui";

import { formatCurrency, formatValue } from "#/utils/valueFormatters";

interface OverviewCellProps {
  title: string;
  value: number;
  isCurrency?: boolean;
}

export const OverviewCell: React.FC<OverviewCellProps> = ({
  title,
  value,
  isCurrency = false,
}) => {
  const formattedValue = isCurrency
    ? formatCurrency(value, { precision: 0 })
    : formatValue(value, { precision: 0 });

  return (
    <div className="flex flex-col gap-1">
      <Typography size={10} className="text-textSecondary">
        {title}
      </Typography>
      <Typography bold size={16} className="text-textPrimary">
        {formattedValue}
      </Typography>
    </div>
  );
};
